import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import { get as _get } from "lodash";

import { CustomModal, showAlertMessage } from "../common/formElements";

import { updateCompanyLeadCap } from "../../redux/services/campaignSetup";

import { updateLoadingState } from "../../redux/actions/application";

class CompanyLeadCap extends Component {

  state = {
    companyLeadCap: "",
    showModal: false
  };

  _showModal = () => {
    const { campaignId, intl, leadsPerCompany } = this.props;

    if ((campaignId || null) === null) {
      showAlertMessage(intl.formatMessage({ id: "error.select_atleast_one", defaultMessage: "Please select at least one {field}." },
        { field: intl.formatMessage({ id: "campaign", defaultMessage: "campaign" }) }
      ));
      return false;
    }

    this.setState({ companyLeadCap: `${leadsPerCompany ?? ""}`, showModal: true });
  }

  _closeModal = () => {
    this.setState({ companyLeadCap: "", showModal: false });
  }

  _submitCompanyLeadCap = async () => {
    const { campaignId, updateLoadingState, intl } = this.props;
    const { companyLeadCap } = this.state;

    if (!/^\d+$/.test(companyLeadCap) || Number(companyLeadCap) < 1) {
      showAlertMessage("Please enter a valid number of leads per company.");
      return false;
    }

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await updateCompanyLeadCap(campaignId, { leads_per_company: Number(companyLeadCap) });

      if ((response.flag || false) === true) {
        showAlertMessage(_get(response, "message", "Company lead cap updated successfully."), "success");
        this._closeModal();
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while updating company lead cap."));
      }
    } catch (error) {
      showAlertMessage(_get(error, "message", intl.formatMessage({ id: "message.something_went_wrong", defaultMessage: "Something went wrong." })));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  _renderModalContent = () => {
    const { intl } = this.props;
    const { showModal, companyLeadCap } = this.state;

    return (
      <CustomModal
        isOpen={showModal}
        className="text-capitalize"
        modalTitle="Company Lead Cap"
        onHide={() => this._closeModal()}
        onClose={() => this._closeModal()}
      >
        <>
          <div className="mb-4">
            <label className="form-label" htmlFor="company-lead-cap">
              {intl.formatMessage({ id: "campaign_setup.campaign_brief.company_lead_cap.checkbox", defaultMessage: "Cap on leads per company" })}
            </label>
            <input
              type="text"
              id="company-lead-cap"
              className="form-control"
              inputMode="numeric"
              pattern="[0-9]*"
              value={companyLeadCap}
              onChange={(e) => this.setState({ companyLeadCap: e.currentTarget.value })}
            />
          </div>

          <div className="pt-4 px-4 mx-n4 d-flex gap-3 align-items-center justify-content-end border-top">
            <button className="btn btn-outline-primary" onClick={() => this._closeModal()}>
              <FormattedMessage id="btn.cancel" defaultMessage="Cancel" />
            </button>
            <button className="btn btn-primary text-capitalize" onClick={() => this._submitCompanyLeadCap()}>
              <FormattedMessage id="btn.submit" defaultMessage="submit" />
            </button>
          </div>
        </>
      </CustomModal>
    );
  }

  render() {
    return (
      <>
        {this._renderModalContent()}

        <Dropdown.Item className="dropdown-item d-block waves-effect text-capitalize" onClick={() => this._showModal()}>
          Company Lead Cap
        </Dropdown.Item>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data)),
});

export default connect(null, mapDispatchToProps)(injectIntl(CompanyLeadCap));
